import React from 'react';
import { css } from '@emotion/core';
import Tooltip from './Tooltip';


const S3Animation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg1234"
    viewBox="0 0 347.90637 146.06736"
    height="70.06735mm"
    width="100.90637mm"
  >
    <defs
      id="defs1228"
    />
    <g
      css={css`display:inline`}
      id="layer2"
    >
      <g
        css={css`stroke-width:1.35324824`}
        transform="matrix(0.73896272,0,0,0.73896272,-75.288103,135.19814)"
        id="g5441"
      >
        <path
          d="m 137.66909,-19.95869 v 2.27542 c 0,1.905 1.93944,3.43958 4.34702,3.43958 h 36.11363 c 2.40758,0 4.34701,-1.53458 4.34701,-3.43958 v -2.27542 z"
          id="path1998"
          css={css`fill:#3a70bf;stroke-width:0.71609378`}
        />
        <path
          d="m 139.20727,-39.16744 h 42.26632 v 5.13292 h -42.26632 z"
          id="path2000"
          css={css`fill:#ff5252;fill-opacity:1;stroke-width:0.71609378`}
        />
        <path
          d="m 139.20727,-58.429106 h 42.26632 v 5.132916 h -42.26632 z"
          id="path2002"
          css={css`fill:#ff5252;fill-opacity:1;stroke-width:0.71609378`}
        />
        <g
          id="g2010"
          transform="matrix(0.66877093,0,0,0.52916667,15.484642,-80.707023)"
          css={css`fill:#6590db;fill-opacity:0.89320391;stroke-width:1.20374644`}
        >
          <path
            d="m 182.3,15.5 h 67.8 c 1.9,0 3.4,1.5 3.4,3.4 v 19.9 c 0,1.9 -1.5,3.4 -3.4,3.4 h -67.8 c -1.9,0 -3.4,-1.5 -3.4,-3.4 v -20 c 0.1,-1.8 1.6,-3.3 3.4,-3.3 z"
            id="path2004"
            css={css`fill:#6590db;fill-opacity:0.89320391;stroke-width:1.20374644`}
          />
          <path
            d="m 182.3,51.8 h 67.8 c 1.9,0 3.4,1.5 3.4,3.4 v 19.9 c 0,1.9 -1.5,3.4 -3.4,3.4 h -67.8 c -1.9,0 -3.4,-1.5 -3.4,-3.4 V 55.2 c 0.1,-1.9 1.6,-3.4 3.4,-3.4 z"
            id="path2006"
            css={css`fill:#6590db;fill-opacity:0.89320391;stroke-width:1.20374644`}
          />
          <path
            d="m 182.3,88.2 h 67.8 c 1.9,0 3.4,1.5 3.4,3.4 v 19.9 c 0,1.9 -1.5,3.4 -3.4,3.4 h -67.8 c -1.9,0 -3.4,-1.5 -3.4,-3.4 V 91.6 c 0.1,-1.9 1.6,-3.4 3.4,-3.4 z"
            id="path2008"
            css={css`fill:#6590db;fill-opacity:0.89320391;stroke-width:1.20374644`}
          />
        </g>
        <path
          css={css`stroke-width:0.71609378`}
          d="m 137.13408,-35.674941 c -2.14008,0 -3.87888,1.37583 -3.94576,3.12208 v 10.53042 c 0,1.27 1.00316,2.43417 2.54134,2.91042 v 1.16416 c 0,2.64584 2.67508,4.7625 6.01894,4.7625 h 36.11363 c 3.34385,0 6.01894,-2.11666 6.01894,-4.7625 v -1.16416 c 1.53817,-0.47625 2.54132,-1.5875 2.54132,-2.91042 v -10.53042 c 0,-1.5875 -1.53816,-2.91041 -3.54448,-3.06916 v -2.54 c 2.00632,-0.15875 3.54448,-1.48167 3.54448,-3.06917 v -10.58333 c 0,-1.587503 -1.53816,-2.91042 -3.54448,-3.06917 v -2.54 c 2.00632,-0.15875 3.54448,-1.481666 3.54448,-3.069166 v -10.583334 c 0,-1.693333 -1.7388,-3.069166 -3.94574,-3.122083 h -45.34267 c -2.14008,0 -3.87888,1.375833 -3.94576,3.122083 v 10.530417 c 0,1.693333 1.73882,3.122083 3.94576,3.122083 h 0.13375 v 2.487084 h -0.13375 c -2.14008,0 -3.87888,1.375833 -3.94576,3.122086 v 10.53041 c 0,1.69334 1.73882,3.12209 3.94576,3.12209 h 0.13375 v 2.48708 z m 43.40323,17.67417 c 0,1.16416 -1.20379,2.11666 -2.67508,2.11666 H 141.7486 c -1.4713,0 -2.67509,-0.9525 -2.67509,-2.11666 v -0.9525 h 41.4638 z m -43.40323,-42.068753 c -0.33439,0 -0.53503,-0.211667 -0.60189,-0.47625 v -10.530417 c 0,-0.264583 0.2675,-0.423333 0.60189,-0.47625 h 45.34267 c 0.33438,0 0.53501,0.211667 0.60189,0.47625 v 10.530417 c 0,0.264583 -0.26751,0.423333 -0.60189,0.47625 z m 42.40007,2.645833 v 2.487084 h -38.92247 v -2.487084 z m -42.40007,16.61583 c -0.33439,0 -0.53503,-0.21166 -0.60189,-0.47625 v -10.53041 c 0,-0.26459 0.2675,-0.42334 0.60189,-0.47625 h 45.34267 c 0.33438,0 0.53501,0.21166 0.60189,0.47625 v 10.53041 c 0,0.26459 -0.26751,0.42334 -0.60189,0.47625 z m 42.40007,2.64584 v 2.48708 h -38.92247 v -2.48708 z m 2.9426,5.13291 c 0.33438,0 0.53501,0.21167 0.60189,0.47625 v 10.53042 c 0,0.26458 -0.26751,0.42333 -0.60189,0.47625 h -45.34267 c -0.33439,0 -0.53503,-0.21167 -0.60189,-0.47625 v -10.53042 c 0,-0.26458 0.2675,-0.42333 0.60189,-0.47625 z"
          id="path2052"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 142.68487,-62.18619 c 0.93629,0 1.67193,-0.582083 1.67193,-1.322916 v -3.915834 c 0,-0.740833 -0.73564,-1.322916 -1.67193,-1.322916 -0.93627,0 -1.67192,0.582083 -1.67192,1.322916 v 3.915834 c 0,0.740833 0.73565,1.322916 1.67192,1.322916 z"
          id="path2054"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 148.90444,-62.18619 c 0.93629,0 1.67193,-0.582083 1.67193,-1.322916 v -3.915834 c 0,-0.740833 -0.73564,-1.322916 -1.67193,-1.322916 -0.93627,0 -1.67192,0.582083 -1.67192,1.322916 v 3.915834 c 0,0.740833 0.73565,1.322916 1.67192,1.322916 z"
          id="path2056"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 155.05714,-62.18619 c 0.93628,0 1.67192,-0.582083 1.67192,-1.322916 v -3.915834 c 0,-0.740833 -0.73564,-1.322916 -1.67192,-1.322916 -0.93628,0 -1.67193,0.582083 -1.67193,1.322916 v 3.915834 c 0,0.740833 0.80253,1.322916 1.67193,1.322916 z"
          id="path2058"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 161.27671,-62.18619 c 0.93628,0 1.67192,-0.582083 1.67192,-1.322916 v -3.915834 c 0,-0.740833 -0.73564,-1.322916 -1.67192,-1.322916 -0.93629,0 -1.67193,0.582083 -1.67193,1.322916 v 3.915834 c 0,0.740833 0.73564,1.322916 1.67193,1.322916 z"
          id="path2060"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 167.49628,-62.18619 c 0.93628,0 1.67192,-0.582083 1.67192,-1.322916 v -3.915834 c 0,-0.740833 -0.73564,-1.322916 -1.67192,-1.322916 -0.93629,0 -1.67193,0.582083 -1.67193,1.322916 v 3.915834 c 0,0.740833 0.73564,1.322916 1.67193,1.322916 z"
          id="path2062"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 173.64897,-64.144106 h 4.28014 c 0.93627,0 1.67192,-0.582084 1.67192,-1.322917 0,-0.740833 -0.73565,-1.322917 -1.67192,-1.322917 h -4.28014 c -0.93627,0 -1.67193,0.582084 -1.67193,1.322917 0,0.740833 0.73566,1.322917 1.67193,1.322917 z"
          id="path2064"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 142.68487,-42.92452 c 0.93629,0 1.67193,-0.58209 1.67193,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67193,-1.32292 -0.93627,0 -1.67192,0.58208 -1.67192,1.32292 v 3.91583 c 0,0.74083 0.73565,1.32292 1.67192,1.32292 z"
          id="path2066"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 148.90444,-42.92452 c 0.93629,0 1.67193,-0.58209 1.67193,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67193,-1.32292 -0.93627,0 -1.67192,0.58208 -1.67192,1.32292 v 3.91583 c 0,0.74083 0.73565,1.32292 1.67192,1.32292 z"
          id="path2068"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 155.05714,-42.92452 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93628,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.80253,1.32292 1.67193,1.32292 z"
          id="path2070"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 161.27671,-42.92452 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93629,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.73564,1.32292 1.67193,1.32292 z"
          id="path2072"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 167.49628,-42.92452 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93629,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.73564,1.32292 1.67193,1.32292 z"
          id="path2074"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 173.64897,-44.88244 h 4.28014 c 0.93627,0 1.67192,-0.58208 1.67192,-1.32292 0,-0.74083 -0.73565,-1.32291 -1.67192,-1.32291 h -4.28014 c -0.93627,0 -1.67193,0.58208 -1.67193,1.32291 0,0.68792 0.73566,1.32292 1.67193,1.32292 z"
          id="path2076"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 142.68487,-23.71577 c 0.93629,0 1.67193,-0.58209 1.67193,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67193,-1.32292 -0.93627,0 -1.67192,0.58208 -1.67192,1.32292 v 3.91583 c 0,0.74083 0.73565,1.32292 1.67192,1.32292 z"
          id="path2078"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 148.90444,-23.71577 c 0.93629,0 1.67193,-0.58209 1.67193,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67193,-1.32292 -0.93627,0 -1.67192,0.58208 -1.67192,1.32292 v 3.91583 c 0,0.74083 0.73565,1.32292 1.67192,1.32292 z"
          id="path2080"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 155.05714,-23.71577 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93628,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.80253,1.32292 1.67193,1.32292 z"
          id="path2082"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 161.27671,-23.71577 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93629,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.73564,1.32292 1.67193,1.32292 z"
          id="path2084"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 167.49628,-23.71577 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93629,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.73564,1.32292 1.67193,1.32292 z"
          id="path2086"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 173.64897,-25.67369 h 4.28014 c 0.93627,0 1.67192,-0.58208 1.67192,-1.32292 0,-0.74083 -0.73565,-1.32291 -1.67192,-1.32291 h -4.28014 c -0.93627,0 -1.67193,0.58208 -1.67193,1.32291 0,0.74084 0.73566,1.32292 1.67193,1.32292 z"
          id="path2088"
        />
      </g>
      <g
        css={css`stroke-width:1.91136312`}
        transform="matrix(0.52318678,0,0,0.52318678,156.92202,47.362441)"
        id="g5376"
      >
        <circle
          css={css`fill:#3caadc;stroke-width:1.01142967`}
          cx="40.745838"
          cy="-64.64682"
          r="23.865416"
          id="circle1768"
        />
        <path
          css={css`stroke-width:1.01142967`}
          d="m 40.745833,-39.511397 c 13.917083,0 25.188337,-11.27125 25.188337,-25.18833 0,-13.91709 -11.271254,-25.135421 -25.188337,-25.135421 -13.917083,0 -25.188333,11.271251 -25.188333,25.188331 0.05292,13.86417 11.27125,25.13542 25.188333,25.13542 z m -10.371667,-9.89542 c 1.481667,0.42334 2.963334,0.79375 4.497917,1.00542 0.370417,1.79917 0.9525,3.54542 1.74625,5.23875 -2.434167,-1.16417 -4.550833,-3.33375 -6.244167,-6.24417 z m 2.963334,-19.79083 c -0.15875,3.01625 -0.15875,6.08542 0,9.10167 -2.169584,-0.15875 -4.392084,-0.47625 -6.50875,-0.89959 -0.264584,-2.43416 -0.264584,-4.92125 0,-7.35541 2.169583,-0.42334 4.339166,-0.68792 6.50875,-0.84667 z m -6.085417,-1.905 c 0.370417,-1.905 0.846667,-3.75708 1.5875,-5.50333 1.799167,-0.68792 3.65125,-1.21709 5.503333,-1.5875 -0.3175,1.95791 -0.582083,4.07458 -0.79375,6.29708 -2.2225,0.21167 -4.339166,0.47625 -6.297083,0.79375 z m 6.297083,13.6525 c 0.15875,2.2225 0.423334,4.33917 0.79375,6.29708 -1.905,-0.37041 -3.757083,-0.84666 -5.503333,-1.5875 -0.687917,-1.79916 -1.217083,-3.65125 -1.5875,-5.50333 1.957917,0.3175 4.074583,0.58208 6.297083,0.79375 z m 2.487084,-11.95917 c 3.175,-0.15875 6.297083,-0.15875 9.472083,0 0.15875,3.175 0.15875,6.29709 0,9.47209 -3.175,0.15875 -6.297083,0.15875 -9.472083,0 -0.15875,-3.175 -0.15875,-6.29709 0,-9.47209 z m 4.709583,27.25209 c -0.846667,0 -2.06375,-2.01084 -3.069167,-5.87375 2.06375,0.15875 4.074584,0.15875 6.138334,0 -1.005417,3.86291 -2.2225,5.87375 -3.069167,5.87375 z m -3.65125,-8.62542 c -0.423333,-2.16958 -0.687917,-4.33917 -0.899583,-6.50875 3.01625,0.15875 6.0325,0.15875 9.101666,0 -0.15875,2.16958 -0.47625,4.39208 -0.899583,6.50875 -2.434167,0.26458 -4.868333,0.26458 -7.3025,0 z m 7.77875,7.62 c 0.740833,-1.69333 1.322917,-3.43958 1.74625,-5.23875 1.534583,-0.26458 3.01625,-0.58208 4.497917,-1.00542 -1.693334,2.91042 -3.81,5.08 -6.244167,6.24417 z m 3.280833,-26.035 c 2.169584,0.15875 4.392084,0.47625 6.50875,0.89958 0.264584,2.43417 0.264584,4.92125 0,7.35542 -2.169583,0.42333 -4.339166,0.68792 -6.50875,0.89958 0.105834,-3.12208 0.105834,-6.13833 0,-9.15458 z m -0.211666,-2.69875 c -0.15875,-2.2225 -0.423334,-4.33917 -0.79375,-6.29708 1.905,0.37041 3.757083,0.84666 5.503333,1.5875 0.687917,1.79916 1.217083,3.65125 1.5875,5.50333 -1.957917,-0.3175 -4.074583,-0.58208 -6.297083,-0.79375 z m 0,14.44625 c 2.2225,-0.15875 4.339166,-0.42333 6.297083,-0.79375 -0.370417,1.905 -0.846667,3.75708 -1.5875,5.50333 -1.799167,0.68792 -3.65125,1.21709 -5.503333,1.5875 0.370416,-1.95791 0.635,-4.07458 0.79375,-6.29708 z m 2.804583,12.96458 c 1.640417,-1.85208 2.963333,-3.96875 3.915833,-6.24416 2.275417,-1.00542 4.339167,-2.32834 6.244167,-3.91584 -2.169583,4.39209 -5.767917,7.9375 -10.16,10.16 z m 5.23875,-9.8425 c 0.423333,-1.48166 0.79375,-2.96333 1.005417,-4.49791 1.799166,-0.37042 3.545416,-0.9525 5.23875,-1.74625 -1.164167,2.43416 -3.33375,4.60375 -6.244167,6.24416 z m 7.3025,-10.31875 c 0,0.84667 -2.010833,2.06375 -5.87375,3.06917 0.15875,-2.06375 0.15875,-4.07458 0,-6.13833 3.81,1.00541 5.87375,2.2225 5.87375,3.06916 z m -6.244167,-5.87375 c -0.264583,-1.53458 -0.582083,-3.01625 -1.005416,-4.49791 2.910416,1.69333 5.08,3.81 6.297083,6.24416 -1.74625,-0.79375 -3.4925,-1.37583 -5.291667,-1.74625 z m 3.862917,-4.18041 c -1.852083,-1.64042 -3.96875,-2.96334 -6.244167,-3.91584 -1.005416,-2.27541 -2.328333,-4.33916 -3.915833,-6.24416 4.392083,2.2225 7.990417,5.76791 10.16,10.16 z m -9.789583,-5.23875 c -1.481667,-0.42334 -2.963334,-0.79375 -4.497917,-1.00542 -0.370417,-1.79917 -0.9525,-3.54542 -1.74625,-5.23875 2.434167,1.16417 4.550833,3.38667 6.244167,6.24417 z m -10.371667,-7.249588 c 0.846667,0 2.06375,2.010838 3.069167,5.873748 -2.06375,-0.15875 -4.074584,-0.15875 -6.138334,0 1.005417,-3.86291 2.2225,-5.873748 3.069167,-5.873748 z m 3.65125,8.625418 c 0.423333,2.16958 0.687917,4.33917 0.899583,6.50875 -3.01625,-0.15875 -6.0325,-0.15875 -9.101666,0 0.15875,-2.16958 0.47625,-4.39208 0.899583,-6.50875 2.434167,-0.26458 4.868333,-0.26458 7.3025,0 z m -7.77875,-7.62 c -0.740833,1.69333 -1.322917,3.43958 -1.74625,5.23875 -1.534583,0.26458 -3.01625,0.58208 -4.497917,1.00542 1.693334,-2.8575 3.81,-5.08 6.244167,-6.24417 z m -5.87375,1.37583 c -1.640417,1.85209 -2.963333,3.96875 -3.915833,6.24417 -2.275417,1.00542 -4.339167,2.32833 -6.244167,3.91583 2.169583,-4.445 5.767917,-7.99041 10.16,-10.16 z m -5.23875,9.78959 c -0.423333,1.48166 -0.79375,2.96333 -1.005417,4.49791 -1.799166,0.37042 -3.545416,0.9525 -5.23875,1.74625 1.164167,-2.43416 3.33375,-4.60375 6.244167,-6.24416 z m -7.3025,10.37166 c 0,-0.84666 2.010833,-2.06375 5.87375,-3.06916 -0.15875,2.06375 -0.15875,4.07458 0,6.13833 -3.81,-1.05833 -5.87375,-2.27542 -5.87375,-3.06917 z m 6.244167,5.82084 c 0.264583,1.53458 0.582083,3.01625 1.005416,4.49791 -2.910416,-1.69333 -5.08,-3.81 -6.297083,-6.24416 1.74625,0.79375 3.4925,1.37583 5.291667,1.74625 z m 2.38125,8.09625 c 1.005416,2.27541 2.328333,4.33916 3.915833,6.24416 -4.392083,-2.16958 -7.9375,-5.76791 -10.16,-10.16 1.852083,1.5875 3.96875,2.91042 6.244167,3.91584 z"
          id="path1790"
        />
      </g>
      <g
        css={css`stroke-width:0.61561233`}
        transform="matrix(1.624399,0,0,1.624399,54.389429,-38.433147)"
        id="g5650"
      >
        <rect
          css={css`fill:#3a70bf;fill-opacity:1;stroke:#000000;stroke-width:0.61561233;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1`}
          id="rect5117"
          width="24.619135"
          height="2.6894319"
          x="62.876041"
          y="76.789948"
        />
        <path
          css={css`display:inline;fill:#6590db;fill-opacity:0.89411765;stroke-width:0.3257615`}
          d="m 61.279396,52.849929 h 28.79099 c 0.53221,0 0.97858,0.404577 0.97858,0.922442 v 6.101065 c 0,0.50168 -0.4292,0.922443 -0.97858,0.922443 h -28.79099 c -0.53222,0 -0.97859,-0.404581 -0.97859,-0.922443 v -6.101065 c 0,-0.517865 0.4292,-0.922442 0.97859,-0.922442 z"
          id="path1822"
        />
        <g
          transform="matrix(0.17168155,0,0,0.161832,58.154786,50.827027)"
          css={css`display:inline;fill:#173f7f;stroke-width:1.95436549`}
          id="g1848"
        >
          <path
            d="m 131.4,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1828"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 131.4,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1830"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 110.9,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1832"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 110.9,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1834"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 90.4,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 H 90.4 C 89,33.2 87.8,32 87.8,30.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1836"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 90.4,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1838"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 151.9,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1840"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 151.9,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1842"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 172.4,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1844"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 172.4,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1846"
            css={css`stroke-width:1.95436549`}
          />
        </g>
        <ellipse
          css={css`display:inline;fill:#70d6f9;stroke-width:0.3257615`}
          cx="69.382812"
          cy="56.733898"
          id="circle1850"
          rx="1.6824793"
          ry="1.5859536"
        />
        <ellipse
          css={css`display:inline;fill:#ef4460;stroke-width:0.3257615`}
          cx="64.249527"
          cy="56.814816"
          id="circle1852"
          rx="1.6824793"
          ry="1.5859536"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 90.053226,61.184275 c 0.77256,0 1.40778,-0.598779 1.40778,-1.327023 v -6.084881 c 0,-0.728244 -0.63522,-1.327023 -1.40778,-1.327023 h -28.77383 c -0.77257,0 -1.40779,0.598779 -1.40779,1.327023 v 6.101065 c 0,0.728244 0.63522,1.327024 1.40779,1.327024 h 28.77383 z m -29.32322,-1.327023 v -6.084881 c 0,-0.275116 0.24036,-0.517865 0.54939,-0.517865 h 28.79099 c 0.29186,0 0.54938,0.226567 0.54938,0.517865 v 6.101065 c 0,0.275114 -0.24035,0.517862 -0.54938,0.517862 h -28.79099 c -0.30903,-0.01618 -0.54939,-0.242748 -0.54939,-0.534046 z"
          id="path1926"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 80.713746,56.604429 h 1.21894 c 0.48071,0 0.87557,-0.372213 0.87557,-0.825343 v -1.149007 c 0,-0.45313 -0.39486,-0.825343 -0.87557,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825343 v 1.149007 c 0,0.45313 0.39487,0.825343 0.87558,0.825343 z m -0.0172,-1.97435 c 0,-0.01618 0.0172,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149007 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1928"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 80.713746,59.824887 h 1.21894 c 0.48071,0 0.87557,-0.372213 0.87557,-0.825344 v -1.149005 c 0,-0.453131 -0.39486,-0.825344 -0.87557,-0.825344 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825344 v 1.149005 c 0,0.469312 0.39487,0.825344 0.87558,0.825344 z m -0.0172,-1.974349 c 0,0 0.0172,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149005 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1930"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 77.194276,56.604429 h 1.21894 c 0.4807,0 0.87557,-0.372213 0.87557,-0.825343 v -1.149007 c 0,-0.45313 -0.39487,-0.825343 -0.87557,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825343 v 1.149007 c 0,0.45313 0.39487,0.825343 0.87558,0.825343 z m -0.0171,-1.97435 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149007 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21893 c 0,0 -0.0172,0 -0.0172,-0.01618 z"
          id="path1932"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 77.194276,59.824887 h 1.21894 c 0.4807,0 0.87557,-0.372213 0.87557,-0.825344 v -1.149005 c 0,-0.453131 -0.39487,-0.825344 -0.87557,-0.825344 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825344 v 1.149005 c 0,0.469312 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.974349 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149005 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21893 c 0,0 -0.0172,0 -0.0172,-0.01618 z"
          id="path1934"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 73.674806,56.604429 h 1.21893 c 0.48071,0 0.87558,-0.372213 0.87558,-0.825343 v -1.149007 c 0,-0.45313 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21893 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825343 v 1.149007 c 0,0.45313 0.39487,0.825343 0.87558,0.825343 z m -0.0171,-1.97435 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149007 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21893 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1936"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 73.674806,59.824887 h 1.21893 c 0.48071,0 0.87558,-0.372213 0.87558,-0.825344 v -1.149005 c 0,-0.453131 -0.39487,-0.825344 -0.87558,-0.825344 h -1.21893 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825344 v 1.149005 c 0,0.469312 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.974349 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149005 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21893 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1938"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 84.233216,56.604429 h 1.21894 c 0.48071,0 0.87558,-0.372213 0.87558,-0.825343 v -1.149007 c 0,-0.45313 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825343 v 1.149007 c 0,0.45313 0.39487,0.825343 0.87558,0.825343 z m -0.0171,-1.97435 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149007 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0172,0 -0.0172,-0.01618 z"
          id="path1940"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 84.233216,59.824887 h 1.21894 c 0.48071,0 0.87558,-0.372213 0.87558,-0.825344 v -1.149005 c 0,-0.453131 -0.39487,-0.825344 -0.87558,-0.825344 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825344 v 1.149005 c 0,0.469312 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.974349 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149005 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0172,0 -0.0172,-0.01618 z"
          id="path1942"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 87.752686,56.604429 h 1.21894 c 0.48071,0 0.87558,-0.372213 0.87558,-0.825343 v -1.149007 c 0,-0.45313 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825343 v 1.149007 c 0,0.45313 0.39487,0.825343 0.87558,0.825343 z m -0.0171,-1.97435 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149007 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1944"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 87.752686,59.824887 h 1.21894 c 0.48071,0 0.87558,-0.372213 0.87558,-0.825344 v -1.149005 c 0,-0.453131 -0.39487,-0.825344 -0.87558,-0.825344 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825344 v 1.149005 c 0,0.469312 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.974349 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149005 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1946"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 69.382756,58.708246 c 1.16744,0 2.11168,-0.890077 2.11168,-1.990533 0,-1.100457 -0.94424,-1.990534 -2.11168,-1.990534 -1.16743,0 -2.11168,0.890077 -2.11168,1.990534 0,1.100456 0.94425,1.990533 2.11168,1.990533 z m 0,-3.155724 c 0.68673,0 1.25328,0.534045 1.25328,1.181375 0,0.647326 -0.56655,1.181371 -1.25328,1.181371 -0.68672,0 -1.25327,-0.534045 -1.25327,-1.181371 0,-0.663513 0.56655,-1.181375 1.25327,-1.181375 z"
          id="path1948"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 64.249476,58.805345 c 1.16744,0 2.11169,-0.890077 2.11169,-1.990534 0,-1.100456 -0.94425,-1.990533 -2.11169,-1.990533 -1.16743,0 -2.11168,0.906258 -2.11168,1.990533 0,1.100457 0.94425,1.990534 2.11168,1.990534 z m 0,-3.155724 c 0.68673,0 1.25328,0.534046 1.25328,1.181375 0,0.647325 -0.56655,1.181371 -1.25328,1.181371 -0.68672,0 -1.25327,-0.534046 -1.25327,-1.181371 0,-0.663514 0.56655,-1.181375 1.25327,-1.181375 z"
          id="path1950"
        />
        <path
          css={css`display:inline;fill:#6590db;fill-opacity:0.89411765;stroke-width:0.3257615`}
          d="m 61.279396,60.941534 h 28.79099 c 0.53221,0 0.97858,0.404578 0.97858,0.922442 v 6.101065 c 0,0.501681 -0.4292,0.922442 -0.97858,0.922442 h -28.79099 c -0.53222,0 -0.97859,-0.404581 -0.97859,-0.922442 v -6.101065 c 0,-0.517864 0.4292,-0.922442 0.97859,-0.922442 z"
          id="path1822-7"
        />
        <g
          transform="matrix(0.17168155,0,0,0.161832,58.154786,58.918632)"
          css={css`display:inline;fill:#173f7f;stroke-width:1.95436549`}
          id="g1848-9"
        >
          <path
            d="m 131.4,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1828-3"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 131.4,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1830-8"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 110.9,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1832-0"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 110.9,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1834-2"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 90.4,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 H 90.4 C 89,33.2 87.8,32 87.8,30.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1836-4"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 90.4,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1838-8"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 151.9,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1840-3"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 151.9,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1842-9"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 172.4,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1844-0"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 172.4,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1846-5"
            css={css`stroke-width:1.95436549`}
          />
        </g>
        <ellipse
          css={css`display:inline;fill:#70d6f9;stroke-width:0.3257615`}
          cx="69.382812"
          cy="64.825516"
          id="circle1850-2"
          rx="1.6824793"
          ry="1.5859536"
        />
        <ellipse
          css={css`display:inline;fill:#ef4460;stroke-width:0.3257615`}
          cx="64.249527"
          cy="64.906433"
          id="circle1852-2"
          rx="1.6824793"
          ry="1.5859536"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 90.053226,69.27588 c 0.77256,0 1.40778,-0.598779 1.40778,-1.327023 v -6.084881 c 0,-0.728244 -0.63522,-1.327023 -1.40778,-1.327023 h -28.77383 c -0.77257,0 -1.40779,0.598779 -1.40779,1.327023 v 6.101065 c 0,0.728244 0.63522,1.327024 1.40779,1.327024 h 28.77383 z m -29.32322,-1.327023 v -6.084881 c 0,-0.275116 0.24036,-0.517864 0.54939,-0.517864 h 28.79099 c 0.29186,0 0.54938,0.226566 0.54938,0.517864 v 6.101065 c 0,0.275114 -0.24035,0.517861 -0.54938,0.517861 h -28.79099 c -0.30903,-0.01618 -0.54939,-0.242747 -0.54939,-0.534045 z"
          id="path1926-7"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 80.713746,64.696034 h 1.21894 c 0.48071,0 0.87557,-0.372213 0.87557,-0.825344 v -1.149005 c 0,-0.453131 -0.39486,-0.825344 -0.87557,-0.825344 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825344 v 1.149005 c 0,0.453131 0.39487,0.825344 0.87558,0.825344 z m -0.0172,-1.974349 c 0,-0.01618 0.0172,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149005 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1928-3"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 80.713746,67.916492 h 1.21894 c 0.48071,0 0.87557,-0.372212 0.87557,-0.825344 v -1.149006 c 0,-0.45313 -0.39486,-0.825343 -0.87557,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825343 v 1.149006 c 0,0.469312 0.39487,0.825344 0.87558,0.825344 z m -0.0172,-1.97435 c 0,0 0.0172,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149006 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1930-7"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 77.194276,64.696034 h 1.21894 c 0.4807,0 0.87557,-0.372213 0.87557,-0.825344 v -1.149005 c 0,-0.453131 -0.39487,-0.825344 -0.87557,-0.825344 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825344 v 1.149005 c 0,0.453131 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.974349 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149005 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21893 c 0,0 -0.0172,0 -0.0172,-0.01618 z"
          id="path1932-9"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 77.194276,67.916492 h 1.21894 c 0.4807,0 0.87557,-0.372212 0.87557,-0.825344 v -1.149006 c 0,-0.45313 -0.39487,-0.825343 -0.87557,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825343 v 1.149006 c 0,0.469312 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.97435 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149006 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21893 c 0,0 -0.0172,0 -0.0172,-0.01618 z"
          id="path1934-0"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 73.674806,64.696034 h 1.21893 c 0.48071,0 0.87558,-0.372213 0.87558,-0.825344 v -1.149005 c 0,-0.453131 -0.39487,-0.825344 -0.87558,-0.825344 h -1.21893 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825344 v 1.149005 c 0,0.453131 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.974349 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149005 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21893 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1936-2"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 73.674806,67.916492 h 1.21893 c 0.48071,0 0.87558,-0.372212 0.87558,-0.825344 v -1.149006 c 0,-0.45313 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21893 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825343 v 1.149006 c 0,0.469312 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.97435 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149006 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21893 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1938-3"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 84.233216,64.696034 h 1.21894 c 0.48071,0 0.87558,-0.372213 0.87558,-0.825344 v -1.149005 c 0,-0.453131 -0.39487,-0.825344 -0.87558,-0.825344 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825344 v 1.149005 c 0,0.453131 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.974349 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149005 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0172,0 -0.0172,-0.01618 z"
          id="path1940-9"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 84.233216,67.916492 h 1.21894 c 0.48071,0 0.87558,-0.372212 0.87558,-0.825344 v -1.149006 c 0,-0.45313 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825343 v 1.149006 c 0,0.469312 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.97435 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149006 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0172,0 -0.0172,-0.01618 z"
          id="path1942-9"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 87.752686,64.696034 h 1.21894 c 0.48071,0 0.87558,-0.372213 0.87558,-0.825344 v -1.149005 c 0,-0.453131 -0.39487,-0.825344 -0.87558,-0.825344 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825344 v 1.149005 c 0,0.453131 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.974349 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149005 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1944-7"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 87.752686,67.916492 h 1.21894 c 0.48071,0 0.87558,-0.372212 0.87558,-0.825344 v -1.149006 c 0,-0.45313 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372213 -0.87558,0.825343 v 1.149006 c 0,0.469312 0.39487,0.825344 0.87558,0.825344 z m -0.0171,-1.97435 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149006 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1946-0"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 69.382756,66.799851 c 1.16744,0 2.11168,-0.890077 2.11168,-1.990534 0,-1.100456 -0.94424,-1.990534 -2.11168,-1.990534 -1.16743,0 -2.11168,0.890078 -2.11168,1.990534 0,1.100457 0.94425,1.990534 2.11168,1.990534 z m 0,-3.155724 c 0.68673,0 1.25328,0.534046 1.25328,1.181375 0,0.647326 -0.56655,1.181371 -1.25328,1.181371 -0.68672,0 -1.25327,-0.534045 -1.25327,-1.181371 0,-0.663514 0.56655,-1.181375 1.25327,-1.181375 z"
          id="path1948-3"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 64.249476,66.89695 c 1.16744,0 2.11169,-0.890077 2.11169,-1.990533 0,-1.100457 -0.94425,-1.990534 -2.11169,-1.990534 -1.16743,0 -2.11168,0.906258 -2.11168,1.990534 0,1.100456 0.94425,1.990533 2.11168,1.990533 z m 0,-3.155724 c 0.68673,0 1.25328,0.534046 1.25328,1.181374 0,0.647327 -0.56655,1.181372 -1.25328,1.181372 -0.68672,0 -1.25327,-0.534045 -1.25327,-1.181372 0,-0.663513 0.56655,-1.181374 1.25327,-1.181374 z"
          id="path1950-9"
        />
        <path
          css={css`display:inline;fill:#6590db;fill-opacity:0.89411765;stroke-width:0.3257615`}
          d="m 61.279396,68.822759 h 28.79099 c 0.53221,0 0.97858,0.404578 0.97858,0.922442 v 6.101065 c 0,0.50168 -0.4292,0.922441 -0.97858,0.922441 h -28.79099 c -0.53222,0 -0.97859,-0.404581 -0.97859,-0.922441 v -6.101065 c 0,-0.517864 0.4292,-0.922442 0.97859,-0.922442 z"
          id="path1822-8"
        />
        <g
          transform="matrix(0.17168155,0,0,0.161832,58.154786,66.799858)"
          css={css`display:inline;fill:#173f7f;stroke-width:1.95436549`}
          id="g1848-6"
        >
          <path
            d="m 131.4,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1828-5"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 131.4,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1830-7"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 110.9,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1832-6"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 110.9,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1834-27"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 90.4,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 H 90.4 C 89,33.2 87.8,32 87.8,30.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1836-0"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 90.4,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1838-3"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 151.9,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1840-9"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 151.9,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1842-99"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 172.4,20.9 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.5 1.2,-2.6 2.6,-2.6 z"
            id="path1844-1"
            css={css`stroke-width:1.95436549`}
          />
          <path
            d="m 172.4,40.8 h 7.1 c 1.4,0 2.6,1.2 2.6,2.6 v 7.1 c 0,1.4 -1.2,2.6 -2.6,2.6 h -7.1 c -1.4,0 -2.6,-1.2 -2.6,-2.6 v -7.1 c 0,-1.4 1.2,-2.6 2.6,-2.6 z"
            id="path1846-7"
            css={css`stroke-width:1.95436549`}
          />
        </g>
        <ellipse
          css={css`display:inline;fill:#70d6f9;stroke-width:0.3257615`}
          cx="69.382812"
          cy="72.706726"
          id="circle1850-23"
          rx="1.6824793"
          ry="1.5859536"
        />
        <ellipse
          css={css`display:inline;fill:#ef4460;stroke-width:0.3257615`}
          cx="64.249527"
          cy="72.787643"
          id="circle1852-6"
          rx="1.6824793"
          ry="1.5859536"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 90.053226,77.157102 c 0.77256,0 1.40778,-0.598779 1.40778,-1.327023 v -6.084878 c 0,-0.728244 -0.63522,-1.327023 -1.40778,-1.327023 h -28.77383 c -0.77257,0 -1.40779,0.598779 -1.40779,1.327023 v 6.101065 c 0,0.728244 0.63522,1.327023 1.40779,1.327023 h 28.77383 z m -29.32322,-1.327023 v -6.084878 c 0,-0.275116 0.24036,-0.517864 0.54939,-0.517864 h 28.79099 c 0.29186,0 0.54938,0.226567 0.54938,0.517864 v 6.101065 c 0,0.275117 -0.24035,0.51786 -0.54938,0.51786 h -28.79099 c -0.30903,-0.01615 -0.54939,-0.242743 -0.54939,-0.534047 z"
          id="path1926-5"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 80.713746,72.577259 h 1.21894 c 0.48071,0 0.87557,-0.372212 0.87557,-0.825343 V 70.60291 c 0,-0.453131 -0.39486,-0.825343 -0.87557,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372212 -0.87558,0.825343 v 1.149006 c 0,0.453131 0.39487,0.825343 0.87558,0.825343 z m -0.0172,-1.974349 c 0,-0.01618 0.0172,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149006 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1928-5"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 80.713746,75.797721 h 1.21894 c 0.48071,0 0.87557,-0.372216 0.87557,-0.825351 v -1.149002 c 0,-0.453131 -0.39486,-0.825343 -0.87557,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372212 -0.87558,0.825343 v 1.149002 c 0,0.469314 0.39487,0.825351 0.87558,0.825351 z m -0.0172,-1.974353 c 0,0 0.0172,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149002 c 0,0 0,0.01615 -0.0171,0.01615 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01615 z"
          id="path1930-8"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 77.194276,72.577259 h 1.21894 c 0.4807,0 0.87557,-0.372212 0.87557,-0.825343 V 70.60291 c 0,-0.453131 -0.39487,-0.825343 -0.87557,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372212 -0.87558,0.825343 v 1.149006 c 0,0.453131 0.39487,0.825343 0.87558,0.825343 z m -0.0171,-1.974349 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149006 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21893 c 0,0 -0.0172,0 -0.0172,-0.01618 z"
          id="path1932-1"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 77.194276,75.797721 h 1.21894 c 0.4807,0 0.87557,-0.372216 0.87557,-0.825351 v -1.149002 c 0,-0.453131 -0.39487,-0.825343 -0.87557,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372212 -0.87558,0.825343 v 1.149002 c 0,0.469314 0.39487,0.825351 0.87558,0.825351 z m -0.0171,-1.974353 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149002 c 0,0 0,0.01615 -0.0171,0.01615 h -1.21893 c 0,0 -0.0172,0 -0.0172,-0.01615 z"
          id="path1934-4"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 73.674806,72.577259 h 1.21893 c 0.48071,0 0.87558,-0.372212 0.87558,-0.825343 V 70.60291 c 0,-0.453131 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21893 c -0.48071,0 -0.87558,0.372212 -0.87558,0.825343 v 1.149006 c 0,0.453131 0.39487,0.825343 0.87558,0.825343 z m -0.0171,-1.974349 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149006 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21893 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1936-7"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 73.674806,75.797721 h 1.21893 c 0.48071,0 0.87558,-0.372216 0.87558,-0.825351 v -1.149002 c 0,-0.453131 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21893 c -0.48071,0 -0.87558,0.372212 -0.87558,0.825343 v 1.149002 c 0,0.469314 0.39487,0.825351 0.87558,0.825351 z m -0.0171,-1.974353 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149002 c 0,0 0,0.01615 -0.0171,0.01615 h -1.21893 c 0,0 -0.0171,0 -0.0171,-0.01615 z"
          id="path1938-1"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 84.233216,72.577259 h 1.21894 c 0.48071,0 0.87558,-0.372212 0.87558,-0.825343 V 70.60291 c 0,-0.453131 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372212 -0.87558,0.825343 v 1.149006 c 0,0.453131 0.39487,0.825343 0.87558,0.825343 z m -0.0171,-1.974349 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149006 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0172,0 -0.0172,-0.01618 z"
          id="path1940-3"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 84.233216,75.797721 h 1.21894 c 0.48071,0 0.87558,-0.372216 0.87558,-0.825351 v -1.149002 c 0,-0.453131 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372212 -0.87558,0.825343 v 1.149002 c 0,0.469314 0.39487,0.825351 0.87558,0.825351 z m -0.0171,-1.974353 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149002 c 0,0 0,0.01615 -0.0171,0.01615 h -1.21894 c 0,0 -0.0172,0 -0.0172,-0.01615 z"
          id="path1942-8"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 87.752686,72.577259 h 1.21894 c 0.48071,0 0.87558,-0.372212 0.87558,-0.825343 V 70.60291 c 0,-0.453131 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372212 -0.87558,0.825343 v 1.149006 c 0,0.453131 0.39487,0.825343 0.87558,0.825343 z m -0.0171,-1.974349 c 0,-0.01618 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149006 c 0,0 0,0.01618 -0.0171,0.01618 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01618 z"
          id="path1944-4"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 87.752686,75.797721 h 1.21894 c 0.48071,0 0.87558,-0.372216 0.87558,-0.825351 v -1.149002 c 0,-0.453131 -0.39487,-0.825343 -0.87558,-0.825343 h -1.21894 c -0.48071,0 -0.87558,0.372212 -0.87558,0.825343 v 1.149002 c 0,0.469314 0.39487,0.825351 0.87558,0.825351 z m -0.0171,-1.974353 c 0,0 0.0171,-0.01618 0,0 l 1.23611,-0.01618 c 0,0 0.0171,0 0.0171,0.01618 v 1.149002 c 0,0 0,0.01615 -0.0171,0.01615 h -1.21894 c 0,0 -0.0171,0 -0.0171,-0.01615 z"
          id="path1946-8"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 69.382756,74.681074 c 1.16744,0 2.11168,-0.890075 2.11168,-1.990531 0,-1.100457 -0.94424,-1.990534 -2.11168,-1.990534 -1.16743,0 -2.11168,0.890077 -2.11168,1.990534 0,1.100456 0.94425,1.990531 2.11168,1.990531 z m 0,-3.155722 c 0.68673,0 1.25328,0.534046 1.25328,1.181375 0,0.647326 -0.56655,1.181372 -1.25328,1.181372 -0.68672,0 -1.25327,-0.534046 -1.25327,-1.181372 0,-0.663513 0.56655,-1.181375 1.25327,-1.181375 z"
          id="path1948-0"
        />
        <path
          css={css`display:inline;stroke-width:0.3257615`}
          d="m 64.249476,74.778173 c 1.16744,0 2.11169,-0.890074 2.11169,-1.990531 0,-1.100456 -0.94425,-1.990534 -2.11169,-1.990534 -1.16743,0 -2.11168,0.906259 -2.11168,1.990534 0,1.100457 0.94425,1.990531 2.11168,1.990531 z m 0,-3.155721 c 0.68673,0 1.25328,0.534045 1.25328,1.181374 0,0.647326 -0.56655,1.18137 -1.25328,1.18137 -0.68672,0 -1.25327,-0.534044 -1.25327,-1.18137 0,-0.663513 0.56655,-1.181374 1.25327,-1.181374 z"
          id="path1950-4"
        />
      </g>
      <path
        id="path5536-7"
        d="M 178.76887,42.448661 V 29.336435"
        css={css`display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1`}
      />
      <path
        id="path5536-5"
        d="m 66.434584,101.33844 108.055746,-0.0763 0.0764,-9.107982"
        css={css`display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1`}
      />
      <g
        css={css`display:inline;stroke-width:1.35324824`}
        transform="matrix(0.73896273,0,0,0.73896273,195.19823,135.30157)"
        id="g5441-8"
      >
        <path
          d="m 137.66909,-19.95869 v 2.27542 c 0,1.905 1.93944,3.43958 4.34702,3.43958 h 36.11363 c 2.40758,0 4.34701,-1.53458 4.34701,-3.43958 v -2.27542 z"
          id="path1998-06"
          css={css`fill:#3a70bf;stroke-width:0.71609378`}
        />
        <path
          d="m 139.20727,-39.16744 h 42.26632 v 5.13292 h -42.26632 z"
          id="path2000-5"
          css={css`fill:#ff5252;fill-opacity:1;stroke-width:0.71609378`}
        />
        <path
          d="m 139.20727,-58.429106 h 42.26632 v 5.132916 h -42.26632 z"
          id="path2002-7"
          css={css`fill:#ff5252;fill-opacity:1;stroke-width:0.71609378`}
        />
        <g
          id="g2010-3"
          transform="matrix(0.66877093,0,0,0.52916667,15.484642,-80.707023)"
          css={css`fill:#6590db;fill-opacity:0.89320391;stroke-width:1.20374644`}
        >
          <path
            d="m 182.3,15.5 h 67.8 c 1.9,0 3.4,1.5 3.4,3.4 v 19.9 c 0,1.9 -1.5,3.4 -3.4,3.4 h -67.8 c -1.9,0 -3.4,-1.5 -3.4,-3.4 v -20 c 0.1,-1.8 1.6,-3.3 3.4,-3.3 z"
            id="path2004-4"
            css={css`fill:#6590db;fill-opacity:0.89320391;stroke-width:1.20374644`}
          />
          <path
            d="m 182.3,51.8 h 67.8 c 1.9,0 3.4,1.5 3.4,3.4 v 19.9 c 0,1.9 -1.5,3.4 -3.4,3.4 h -67.8 c -1.9,0 -3.4,-1.5 -3.4,-3.4 V 55.2 c 0.1,-1.9 1.6,-3.4 3.4,-3.4 z"
            id="path2006-3"
            css={css`fill:#6590db;fill-opacity:0.89320391;stroke-width:1.20374644`}
          />
          <path
            d="m 182.3,88.2 h 67.8 c 1.9,0 3.4,1.5 3.4,3.4 v 19.9 c 0,1.9 -1.5,3.4 -3.4,3.4 h -67.8 c -1.9,0 -3.4,-1.5 -3.4,-3.4 V 91.6 c 0.1,-1.9 1.6,-3.4 3.4,-3.4 z"
            id="path2008-0"
            css={css`fill:#6590db;fill-opacity:0.89320391;stroke-width:1.20374644`}
          />
        </g>
        <path
          css={css`stroke-width:0.71609378`}
          d="m 137.13408,-35.674941 c -2.14008,0 -3.87888,1.37583 -3.94576,3.12208 v 10.53042 c 0,1.27 1.00316,2.43417 2.54134,2.91042 v 1.16416 c 0,2.64584 2.67508,4.7625 6.01894,4.7625 h 36.11363 c 3.34385,0 6.01894,-2.11666 6.01894,-4.7625 v -1.16416 c 1.53817,-0.47625 2.54132,-1.5875 2.54132,-2.91042 v -10.53042 c 0,-1.5875 -1.53816,-2.91041 -3.54448,-3.06916 v -2.54 c 2.00632,-0.15875 3.54448,-1.48167 3.54448,-3.06917 v -10.58333 c 0,-1.587503 -1.53816,-2.91042 -3.54448,-3.06917 v -2.54 c 2.00632,-0.15875 3.54448,-1.481666 3.54448,-3.069166 v -10.583334 c 0,-1.693333 -1.7388,-3.069166 -3.94574,-3.122083 h -45.34267 c -2.14008,0 -3.87888,1.375833 -3.94576,3.122083 v 10.530417 c 0,1.693333 1.73882,3.122083 3.94576,3.122083 h 0.13375 v 2.487084 h -0.13375 c -2.14008,0 -3.87888,1.375833 -3.94576,3.122086 v 10.53041 c 0,1.69334 1.73882,3.12209 3.94576,3.12209 h 0.13375 v 2.48708 z m 43.40323,17.67417 c 0,1.16416 -1.20379,2.11666 -2.67508,2.11666 H 141.7486 c -1.4713,0 -2.67509,-0.9525 -2.67509,-2.11666 v -0.9525 h 41.4638 z m -43.40323,-42.068753 c -0.33439,0 -0.53503,-0.211667 -0.60189,-0.47625 v -10.530417 c 0,-0.264583 0.2675,-0.423333 0.60189,-0.47625 h 45.34267 c 0.33438,0 0.53501,0.211667 0.60189,0.47625 v 10.530417 c 0,0.264583 -0.26751,0.423333 -0.60189,0.47625 z m 42.40007,2.645833 v 2.487084 h -38.92247 v -2.487084 z m -42.40007,16.61583 c -0.33439,0 -0.53503,-0.21166 -0.60189,-0.47625 v -10.53041 c 0,-0.26459 0.2675,-0.42334 0.60189,-0.47625 h 45.34267 c 0.33438,0 0.53501,0.21166 0.60189,0.47625 v 10.53041 c 0,0.26459 -0.26751,0.42334 -0.60189,0.47625 z m 42.40007,2.64584 v 2.48708 h -38.92247 v -2.48708 z m 2.9426,5.13291 c 0.33438,0 0.53501,0.21167 0.60189,0.47625 v 10.53042 c 0,0.26458 -0.26751,0.42333 -0.60189,0.47625 h -45.34267 c -0.33439,0 -0.53503,-0.21167 -0.60189,-0.47625 v -10.53042 c 0,-0.26458 0.2675,-0.42333 0.60189,-0.47625 z"
          id="path2052-4"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 142.68487,-62.18619 c 0.93629,0 1.67193,-0.582083 1.67193,-1.322916 v -3.915834 c 0,-0.740833 -0.73564,-1.322916 -1.67193,-1.322916 -0.93627,0 -1.67192,0.582083 -1.67192,1.322916 v 3.915834 c 0,0.740833 0.73565,1.322916 1.67192,1.322916 z"
          id="path2054-8"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 148.90444,-62.18619 c 0.93629,0 1.67193,-0.582083 1.67193,-1.322916 v -3.915834 c 0,-0.740833 -0.73564,-1.322916 -1.67193,-1.322916 -0.93627,0 -1.67192,0.582083 -1.67192,1.322916 v 3.915834 c 0,0.740833 0.73565,1.322916 1.67192,1.322916 z"
          id="path2056-7"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 155.05714,-62.18619 c 0.93628,0 1.67192,-0.582083 1.67192,-1.322916 v -3.915834 c 0,-0.740833 -0.73564,-1.322916 -1.67192,-1.322916 -0.93628,0 -1.67193,0.582083 -1.67193,1.322916 v 3.915834 c 0,0.740833 0.80253,1.322916 1.67193,1.322916 z"
          id="path2058-5"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 161.27671,-62.18619 c 0.93628,0 1.67192,-0.582083 1.67192,-1.322916 v -3.915834 c 0,-0.740833 -0.73564,-1.322916 -1.67192,-1.322916 -0.93629,0 -1.67193,0.582083 -1.67193,1.322916 v 3.915834 c 0,0.740833 0.73564,1.322916 1.67193,1.322916 z"
          id="path2060-9"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 167.49628,-62.18619 c 0.93628,0 1.67192,-0.582083 1.67192,-1.322916 v -3.915834 c 0,-0.740833 -0.73564,-1.322916 -1.67192,-1.322916 -0.93629,0 -1.67193,0.582083 -1.67193,1.322916 v 3.915834 c 0,0.740833 0.73564,1.322916 1.67193,1.322916 z"
          id="path2062-5"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 173.64897,-64.144106 h 4.28014 c 0.93627,0 1.67192,-0.582084 1.67192,-1.322917 0,-0.740833 -0.73565,-1.322917 -1.67192,-1.322917 h -4.28014 c -0.93627,0 -1.67193,0.582084 -1.67193,1.322917 0,0.740833 0.73566,1.322917 1.67193,1.322917 z"
          id="path2064-3"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 142.68487,-42.92452 c 0.93629,0 1.67193,-0.58209 1.67193,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67193,-1.32292 -0.93627,0 -1.67192,0.58208 -1.67192,1.32292 v 3.91583 c 0,0.74083 0.73565,1.32292 1.67192,1.32292 z"
          id="path2066-2"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 148.90444,-42.92452 c 0.93629,0 1.67193,-0.58209 1.67193,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67193,-1.32292 -0.93627,0 -1.67192,0.58208 -1.67192,1.32292 v 3.91583 c 0,0.74083 0.73565,1.32292 1.67192,1.32292 z"
          id="path2068-7"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 155.05714,-42.92452 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93628,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.80253,1.32292 1.67193,1.32292 z"
          id="path2070-3"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 161.27671,-42.92452 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93629,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.73564,1.32292 1.67193,1.32292 z"
          id="path2072-9"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 167.49628,-42.92452 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93629,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.73564,1.32292 1.67193,1.32292 z"
          id="path2074-7"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 173.64897,-44.88244 h 4.28014 c 0.93627,0 1.67192,-0.58208 1.67192,-1.32292 0,-0.74083 -0.73565,-1.32291 -1.67192,-1.32291 h -4.28014 c -0.93627,0 -1.67193,0.58208 -1.67193,1.32291 0,0.68792 0.73566,1.32292 1.67193,1.32292 z"
          id="path2076-7"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 142.68487,-23.71577 c 0.93629,0 1.67193,-0.58209 1.67193,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67193,-1.32292 -0.93627,0 -1.67192,0.58208 -1.67192,1.32292 v 3.91583 c 0,0.74083 0.73565,1.32292 1.67192,1.32292 z"
          id="path2078-9"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 148.90444,-23.71577 c 0.93629,0 1.67193,-0.58209 1.67193,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67193,-1.32292 -0.93627,0 -1.67192,0.58208 -1.67192,1.32292 v 3.91583 c 0,0.74083 0.73565,1.32292 1.67192,1.32292 z"
          id="path2080-5"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 155.05714,-23.71577 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93628,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.80253,1.32292 1.67193,1.32292 z"
          id="path2082-3"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 161.27671,-23.71577 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93629,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.73564,1.32292 1.67193,1.32292 z"
          id="path2084-3"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 167.49628,-23.71577 c 0.93628,0 1.67192,-0.58209 1.67192,-1.32292 v -3.91583 c 0,-0.74084 -0.73564,-1.32292 -1.67192,-1.32292 -0.93629,0 -1.67193,0.58208 -1.67193,1.32292 v 3.91583 c 0,0.74083 0.73564,1.32292 1.67193,1.32292 z"
          id="path2086-3"
        />
        <path
          css={css`stroke-width:0.71609378`}
          d="m 173.64897,-25.67369 h 4.28014 c 0.93627,0 1.67192,-0.58208 1.67192,-1.32292 0,-0.74083 -0.73565,-1.32291 -1.67192,-1.32291 h -4.28014 c -0.93627,0 -1.67193,0.58208 -1.67193,1.32291 0,0.74084 0.73566,1.32292 1.67193,1.32292 z"
          id="path2088-8"
        />
      </g>
      <path
        id="path5536-5-5"
        d="m 288.78673,101.38534 -108.05575,-0.0763 -0.0764,-9.107991"
        css={css`display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1`}
      />
    </g>
    <circle cx="0" cy="0" r="3" fill="#529fd9">
      <animateMotion dur="1s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear">
        <mpath xlinkHref="#path5536-7" />
      </animateMotion>
    </circle>
    <circle cx="0" cy="0" r="3" fill="#529fd9">
      <animateMotion dur="1.6s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear">
        <mpath xlinkHref="#path5536-5" />
      </animateMotion>
    </circle>
    <circle cx="0" cy="0" r="3" fill="#529fd9">
      <animateMotion dur="1.7s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear">
        <mpath xlinkHref="#path5536-5" />
      </animateMotion>
    </circle>
    <circle cx="0" cy="0" r="3" fill="#529fd9">
      <animateMotion dur="1.6s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear">
        <mpath xlinkHref="#path5536-5-5" />
      </animateMotion>
    </circle>
    <circle cx="0" cy="0" r="3" fill="#529fd9">
      <animateMotion dur="1.7s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear">
        <mpath xlinkHref="#path5536-5-5" />
      </animateMotion>
    </circle>
    <g transform="translate(87,2)">
      <foreignObject
        width={400}
        height={400}
      >
        <Tooltip text="ELB lay between the internet and app instance(s)" width={150} />
      </foreignObject>
    </g>
    <g transform="translate(-19,130)">
      <foreignObject
        width={400}
        height={400}
      >
        <Tooltip text="3 types of AWS ELB" width={300} />
      </foreignObject>
    </g>
  </svg>

);


export default S3Animation;
